import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const STORAGE_KEY = 'custuk-admin-user';

const initialUser = {
    name: '',
    email: '',
    isLoggedIn: false,
    db: 'tdr',
    token: '',
    role: '',
};

// Zustand persist rehydrates on a microtask, which is after the first
// page's useEffect has already fired its request. Read sessionStorage
// now so the axios interceptor sees the token on that first call.
function readStoredUser() {
    try {
        if (typeof sessionStorage === 'undefined') return null;
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const stored = JSON.parse(raw)?.state?.user;
        if (!stored || typeof stored !== 'object') return null;
        return { ...initialUser, ...stored };
    } catch {
        return null;
    }
}

const useUserStore = create(
    persist(
        (set) => ({
            user: readStoredUser() || { ...initialUser },
            setUser: (newData) =>
                set((state) => ({
                    user: { ...state.user, ...newData },
                })),
            setName: (name) =>
                set((state) => ({
                    user: { ...state.user, name },
                })),
            setDB: () =>
                set((state) => ({
                    user: {
                        ...state.user,
                        db: state.user.db === 'tdr' ? 'pro' : 'tdr',
                    },
                })),
            setEmail: (email) =>
                set((state) => ({
                    user: { ...state.user, email },
                })),
            login: () =>
                set((state) => ({
                    user: { ...state.user, isLoggedIn: true },
                })),
            logout: () =>
                set({
                    user: { ...initialUser },
                }),
        }),
        {
            name: STORAGE_KEY,
            storage: createJSONStorage(() => sessionStorage),
            partialize: (state) => ({ user: state.user }),
            skipHydration: true,
        }
    )
);

export default useUserStore;
